import { getExternalAccessToken } from './api';

/** Временно отключён — счётчик людей пока не используется. Вернуть `true`, когда снова понадобится. */
export const PEOPLE_COUNTER_ENABLED = false;

export function isPeopleModel(modelName: string): boolean {
  const key = (modelName || '').trim().toLowerCase();
  return key === 'people' || key === 'person';
}

export function cameraHasPeopleModel(models: string[] | undefined | null): boolean {
  return (models ?? []).some(isPeopleModel);
}

/** Модели, для которых доступен счётчик людей (тот же API /people-counter и WS). */
export function isPeopleCounterModel(modelName: string): boolean {
  if (!PEOPLE_COUNTER_ENABLED) return false;
  const key = (modelName || '').trim().toLowerCase();
  return key === 'people' || key === 'person' || key === 'utrau_staff_detector';
}

export function cameraHasPeopleCounterModel(models: string[] | undefined | null): boolean {
  if (!PEOPLE_COUNTER_ENABLED) return false;
  return (models ?? []).some(isPeopleCounterModel);
}

/** wss://api.flypix.online…/api/ws/people-count/{camera_id} */
export function buildPeopleCountWebSocketUrl(cameraId: string): string | null {
  const token = getExternalAccessToken();
  const apiBase =
    process.env.REACT_APP_EXTERNAL_WS_URL ||
    process.env.REACT_APP_EXTERNAL_API_URL ||
    'https://api.flypix.online:443';

  const wsBase = apiBase.replace(/^https:/i, 'wss:').replace(/^http:/i, 'ws:').replace(/\/$/, '');
  const q = token ? `?token=${encodeURIComponent(token)}` : '';

  return `${wsBase}/api/ws/people-count/${encodeURIComponent(cameraId)}${q}`;
}

export function parsePeopleCountMessage(raw: string): number | null {
  const trimmed = raw.trim();
  if (/^\d+$/.test(trimmed)) {
    return parseInt(trimmed, 10);
  }

  try {
    const data = JSON.parse(trimmed) as unknown;
    if (typeof data === 'number' && Number.isFinite(data)) {
      return Math.max(0, Math.floor(data));
    }
    if (data && typeof data === 'object') {
      const o = data as Record<string, unknown>;
      for (const key of ['count', 'people_count', 'current', 'value', 'total', 'inside', 'occupancy']) {
        const v = o[key];
        if (typeof v === 'number' && Number.isFinite(v)) {
          return Math.max(0, Math.floor(v));
        }
      }
    }
  } catch {
    /* not json */
  }

  return null;
}
